/**
 *  Ranking script file
 **/
import ProgressBar from '@/components/progress-bar/ProgressBar.vue'

export default {
  name: 'Ranking',
  mixins: [],
  components: {
    ProgressBar
  },
  props: {
    bars: {
      type: Array,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    selectedColor: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    total: {
      type: Number,
      required: true
    },
    footer: {
      type: String,
      required: false
    },
    format: {
      type: Function,
      default: n => n,
      required: false
    },
    visibleBars: {
      type: Number,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      barsNumber: 10,
      expanded: false
    }
  },
  methods: {
    toggle () {
      this.expanded = !this.expanded

      if (this.expanded) {
        this.barsNumber = 25
      } else {
        this.barsNumber = this.visibleBars
      }
    },
    close () {
      this.barsNumber = this.visibleBars
      this.expanded = false
    }
  },
  watch: {
    visibleBars (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.barsNumber = newValue
      }
    }
  }
}
